import script from "./PaymentPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentPage.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentPage.vue?vue&type=style&index=0&id=374993d7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374993d7"]])

export default __exports__